<template>
    <modal name="cardDeckTutorialModal" :width="1200" height="auto" :maxHeight="1000" :adaptive="true" :scrollable="true">
        <div class="d-flex flex-column h-100 flex-wrap" style="min-height: 864px">
            <div class="card-deck-tutorial__header">
                <button type="button"
                        class="btn-close"
                        data-dismiss="modal"
                        aria-hidden="true"
                        @click="$modal.hide('cardDeckTutorialModal')">
                </button>
            </div>
            <div v-if="step < 9" class="card-deck-tutorial__content row"
                 :style="{'background-image': step === 0 ? `url('/assets/img/tutorial/welcome_tutorial.png')` : ''}">
                <div class="col-xl-6 mb-2" style="object-fit: contain">
                    <span class="card-deck-tutorial__step">{{ stepData[step].stepText }}
                    </span>
                    <h4 class="card-deck-tutorial__title" v-html="stepData[step].title"></h4>
                    <div class="card-deck-tutorial__description" v-html="stepData[step].description"></div>
                </div>
                <div class="col-xl-6 text-center">
                    <img v-if="stepData[step].image" class="img-fluid" :src="'/assets/img/tutorial/' + stepData[step].image">
                </div>
            </div>
            <div v-else class="flex flex-column flex-1 justify-content-between">
                <div class="flex flex-row" style="margin-bottom: 40px">
                    <img class="img-fluid" style="max-height: 50%" :src="'/assets/img/tutorial/' + stepData[step].image">
                </div>
                <div class="flex-1 d-flex flex-column align-items-center justify-content-center">
                    <div class="col-12 d-flex align-items-center justify-content-center" style="max-width: 50%;">
                        <p class="card-deck-tutorial__step text-center">{{ stepData[step].stepText }}</p>
                    </div>
                    <div class="col-12 d-flex align-items-center justify-content-center" style="max-width: 50%;">
                        <p class="card-deck-tutorial__title text-center" v-html="stepData[step].title"></p>
                    </div>
                    <div class="col-12 d-flex align-items-center justify-content-center" style="max-width: 50%;">
                        <p class="card-deck-tutorial__description text-center" v-html="stepData[step].description"></p>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <btn v-if="step === 0" class="btn-outline-light btn-lg" @click="$modal.hide('cardDeckTutorialModal')">
                    Not now
                </btn>
                <btn v-else class="btn-outline-light btn-lg" @click="previousStep">Back</btn>
                <btn v-if="step < 9" class="btn-primary btn-lg" @click="nextStep">
                    <span v-if="step === 0">Let's get started</span>
                    <span v-else>Next</span>
                    <inline-svg class="ms-1" stroke="white" src="/assets/img/icons/arrow-right.svg"/>
                </btn>
                <btn v-else class="btn-primary btn-lg" @click="finish">
                    Finish tour
                    <inline-svg class="ms-1" stroke="white" src="/assets/img/icons/check-circle-broken.svg"/>
                </btn>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: "CardDeckTutorial",
    props: ['user'],
    data() {
        return {
            step: 0,
            stepData: [
                {
                    title: 'I’m Magnus, the life skills guide.',
                    description: '<span>MagnusTeams is a global community for caregivers, educators, professionals and other supporters <strong>(Support Team)</strong> to empower individuals of all abilities <strong>(Heroes)</strong> to reach and maintain their independent living goals.' +
                        '<br><br>With MagnusTeams, you can build a support team and create Card Decks that provide step-by-step visual support for home, work, and community-based activities.</span>',
                    image: '',
                    stepText: 'Welcome to MagnusTeams!'
                },
                {
                    title: 'Connect with the <span style="color: #FF4D1D">MagnusCards Mobile App</span>',
                    description: '<span>MagnusTeams works with the <strong>MagnusCards mobile app</strong>: the Card Decks you create in MagnusTeams can be shared and used by Heroes in the MagnusCards app.</span><br><br>' +
                        '<span style="font-size: 16px">So - the first thing you should do is make sure you have downloaded MagnusCards (it can be downloaded for free in Apple or Google Play stores). Install MagnusCards on the mobile device that belongs to the Hero, and then create Hero account. Each hero needs their own MagnusCards account.</span><br><br>' +
                        '<div class="card-deck-tutorial__description-note">' +
                        '<div><strong>Note</strong></div>' +
                        '<div>Make sure you remember the Hero username and password! Write it down if it helps. <strong>You will need this to connect with MagnusTeams</strong>.</div>' +
                        '</div><br>' +
                        '<div style="font-size: 16px">P.S. I’m in MagnusCards too, as a guide and cheerleader for the Hero!</div>',
                    image: 'connect_with_magnuscards.png',
                    stepText: 'Step 1'
                },
                {
                    title: 'Add Your Hero(es) in MagnusTeams',
                    description: '<span>Next, add each Hero to MagnusTeams! Use the exact Hero usernames that you created in the previous step. This part is a cinch, you’ll be connected to your Hero(es) in no time.</span>',
                    image: 'add_heroes.png',
                    stepText: 'Step 2'
                },
                {
                    title: 'Create your team',
                    description: '<div>It takes a village…add family members, friends, teachers, occupational therapists, and others who will form the Support Team. </div></br>' +
                        '<div>The Support Team can create Card Decks, schedule activities, monitor progress, and best of all, provide positive reinforcement for each Hero milestone!</div>',
                    image: 'create_your_team.png',
                    stepText: 'Step 3'
                },
                {
                    title: 'MagnusTeams features',
                    description: '<div>And now for a quick tour of MagnusTeams features….</div>',
                    image: 'magnusteams_features.png',
                    stepText: 'Features'
                },
                {
                    title: 'Home',
                    description: '<div style="font-size: 14px; font-weight: 500">Home is where the heart is 😊</div></br>' +
                        '<div>Here you will see an overview of Hero activity in the MagnusCards app, which will display as milestones. </br></br>' +
                        'If you schedule activities for the Hero to complete, they will appear here once done! </br></br>' +
                        'Also, the Support Team can send High Fives as positive feedback to Heroes from the Home page.</div>',
                    image: 'home.png',
                    stepText: 'Feature 1 of 4'
                },
                {
                    title: 'Community Library',
                    description: '<div style="font-size: 14px; font-weight: 500">Here’s the meat and potatoes:</div></br>' +
                        '<div>The <strong>Community Library</strong> contains existing Card Decks created by the caregiver community and Inclusion Partners (agencies, venues, and brands who provide Card Decks to help individuals access their services).</br></br>' +
                        'Use these Card Decks as is or customize for individual Hero needs!</div>',
                    image: 'community_library.png',
                    stepText: 'Feature 2 of 4'
                },
                {
                    title: 'Create Card Decks',
                    description: '<div>Everyone is different, with differing experiences and requiring unique levels of detail. With the Card Deck creation tool, you have the power to <strong>create your very own Card Decks from scratch</strong> or customize existing Card Decks from the Community Library.' +
                        '</br></br>When you’re ready to create your first Card Deck, I’ll walk you through the process with another nifty tutorial.</div>',
                    image: 'create_card_decks.png',
                    stepText: 'Feature 3 of 4'
                },
                {
                    title: 'Schedule Card Decks',
                    description: '<div style="font-size: 14px; font-weight: 500">For the final step on our tour</div></br>' +
                        '<div>The scheduling feature is useful for providing structure that helps people of all abilities to thrive. With MagnusTeams, you can schedule Card Decks!</br></br>' +
                        'Take a second to check out the ‘Schedule’ page in the MagnusCards mobile app. Any Card Decks you schedule will appear there, and a reminder will be sent to the Hero for them to complete the activity at the date and time selected. </br></br>' +
                        'Heroes will receive a gentle reminder from me, along with the Card Deck with visual instruction for completing the task!</div>',
                    image: 'schedule_card_decks.png',
                    stepText: 'Feature 4 of 4'
                },
                {
                    title: 'Are you ready?',
                    description: '<div>That concludes our tour of MagnusTeams. I know it’s all new information, but you’ll get the hang of it in no time. </br></br>' +
                        'Once your Hero is added, why not try your hand at creating your first Card Deck?</div>',
                    image: 'supporters_and_advisors.png',
                    stepText: "Let's Gooo"
                }
            ]
        }
    },
    created() {
        //TODO display only once per user, after finishing save in db (add column for caregiver - tutorial_completed)
    },
    methods: {
        nextStep() {
            this.step++;
        },
        previousStep() {
            this.step--;
        },
        finish() {
            this.$modal.hide('cardDeckTutorialModal')
            this.step = 0;
            this.$http.post('/user/tutorial-viewed');
        }
    }
}
</script>

<style scoped>

</style>
